/**
 * Classifiers for failed requests.
 *
 * Type-only imports, so this module stays free of runtime dependencies and can be unit tested
 * on its own.
 */

import type { AxiosError } from "axios";

const FORBIDDEN = 403;
const NOT_FOUND = 404;

/**
 * Whether a request failed with 404 Not Found
 * @param error The rejected request's error
 * @returns True for a 404 response, false for any other failure
 */
export const isNotFoundError = (error: unknown): boolean =>
  (error as AxiosError | undefined)?.response?.status === NOT_FOUND;

/**
 * Whether a request failed with 403 Forbidden
 * @param error The rejected request's error
 * @returns True for a 403 response, false for any other failure
 */
export const isForbiddenError = (error: unknown): boolean =>
  (error as AxiosError | undefined)?.response?.status === FORBIDDEN;
